import React, { useState } from 'react';
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Paper,
  Button,
  Divider,
  Alert
} from '@mui/material';
import { VolumeUp, Settings, ExpandLess } from '@mui/icons-material';
import { EmergencyTTSSettings as OriginalEmergencyTTSSettings } from '@src/components/emergency-tts-settings';

// 简化版本的紧急呼救语音设置组件
// 复用原组件的功能，但去掉外层包装
const EmergencyTTSSettings: React.FC = () => {
    const [showOriginal, setShowOriginal] = useState(false);

    return (
        <Box>
            {/* 简化的标题和开关 */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <VolumeUp />
                    <Typography variant="subtitle2">紧急呼救语音</Typography>
                </Box>
                
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={showOriginal ? <ExpandLess /> : <Settings />}
                    onClick={() => setShowOriginal(!showOriginal)}
                >
                    {showOriginal ? '收起设置' : '设置'}
                </Button>
            </Box>

            {/* 说明信息 */}
            {!showOriginal && (
                <Alert severity="info" sx={{ mb: 2 }}>
                    <Typography variant="body2">
                        配置紧急情况下播放的语音内容，支持文字转语音和自定义音频文件
                    </Typography>
                </Alert>
            )}

            {/* 展开时显示原组件 */}
            {showOriginal && (
                <Paper 
                    elevation={0} 
                    sx={{ 
                        border: '1px solid', 
                        borderColor: 'divider',
                        borderRadius: 1,
                        overflow: 'hidden'
                    }}
                >
                    <OriginalEmergencyTTSSettings />
                </Paper>
            )}
        </Box>
    );
};

export default EmergencyTTSSettings;